const $ = jQuery.noConflict();

class nextPrevNames {
	constructor(openTrigger, prevNameTrigger, nextNameTrigger) {
		this.openTrigger = $(openTrigger);
		this.prevNameTrigger = $(prevNameTrigger);
		this.nextNameTrigger = $(nextNameTrigger);
	}
	init() {
		this.openTrigger.on('click', this.getThisNames);
		this.prevNameTrigger.on('click', this.getPrevName);
		this.nextNameTrigger.on('click', this.getForNextNames);
	}
	getThisNames() {
		let arrowNext = $(this).closest('.popup-trigger__wrapper').nextAll('article').eq(0).data('fullname');
		let arrowPrev = $(this).closest('.popup-trigger__wrapper').prevAll('article').eq(0).data('fullname');

		if (typeof arrowNext !== 'undefined') {
			$(this).closest('.popup-trigger__wrapper').next('.popup-container__wrapper').find('.popup-trigger__next span').text('Next: ' + arrowNext);
		} else {
			$(this).closest('.popup-trigger__wrapper').next('.popup-container__wrapper').find('.popup-trigger__next').css({'opacity':'0','pointer-events':'none'});
		}
		if (typeof arrowPrev !== 'undefined') {
			$(this).closest('.popup-trigger__wrapper').next('.popup-container__wrapper').find('.popup-trigger__prev span').text('Previous: ' + arrowPrev);
		} else {
			$(this).closest('.popup-trigger__wrapper').next('.popup-container__wrapper').find('.popup-trigger__prev').css({'opacity':'0','pointer-events':'none'});
		}
	}
	getPrevName() {
		let arrowNext = $(this).closest('.popup-container__wrapper').prev('.popup-trigger__wrapper').data('fullname');
		let arrowPrev = $(this).closest('.popup-container__wrapper').prevAll('article').eq(2).data('fullname');

		if (typeof arrowNext !== 'undefined') {
			$(this).closest('.popup-container__wrapper').prevAll('.popup-container__wrapper').eq(0).find('.popup-trigger__next span').text('Next: ' + arrowNext);
		} else {
			$(this).closest('.popup-container__wrapper').prevAll('.popup-container__wrapper').eq(0).find('.popup-trigger__next').css({'opacity':'0','pointer-events':'none'});
		}
		if (typeof arrowPrev !== 'undefined') {
			$(this).closest('.popup-container__wrapper').prevAll('.popup-container__wrapper').eq(0).find('.popup-trigger__prev span').text('Next: ' + arrowPrev);
		} else {
			$(this).closest('.popup-container__wrapper').prevAll('.popup-container__wrapper').eq(0).find('.popup-trigger__prev').css({'opacity':'0','pointer-events':'none'});
		}
	}
	getForNextNames() {
		let arrowNext = $(this).closest('.popup-container__wrapper').nextAll('article').eq(1).data('fullname');
		let arrowPrev = $(this).closest('.popup-container__wrapper').prev('.popup-trigger__wrapper').data('fullname');

		if (typeof arrowNext !== 'undefined') {
			$(this).closest('.popup-container__wrapper').nextAll('.popup-container__wrapper').eq(0).find('.popup-trigger__next span').text('Next: ' + arrowNext);
		} else {
			$(this).closest('.popup-container__wrapper').nextAll('.popup-container__wrapper').eq(0).find('.popup-trigger__next').css({'opacity':'0','pointer-events':'none'});
		}
		if (typeof arrowPrev !== 'undefined') {
			$(this).closest('.popup-container__wrapper').nextAll('.popup-container__wrapper').eq(0).find('.popup-trigger__prev span').text('Next: ' + arrowPrev);
		} else {
			$(this).closest('.popup-container__wrapper').nextAll('.popup-container__wrapper').eq(0).find('.popup-trigger__prev').css({'opacity':'0','pointer-events':'none'});
		}
	}
}

export default new nextPrevNames(
	'.popup-trigger__open',
	'.popup-trigger__prev',
	'.popup-trigger__next'
);
